import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue';
import type { TypeClasses, Types, Props } from '../types';
import { durations } from '../utils';

export default function useTransitionBase(props: MaybeRefOrGetter<Props>) {
  const _props = toValue(props);

  const durationClass = computed(() => durations[_props.duration!]);

  const typeClasses: ComputedRef<Record<Types, TypeClasses>> = computed(() => ({
    slideDown: {
      active: `tw-grid tw-transition-all ${durationClass.value} *:tw-overflow-hidden`,
      invisible: 'tw-grid-rows-[0fr]',
      visible: 'tw-grid-rows-[1fr]',
    },
    slideRight: {
      active: `tw-grid tw-transition-all ${durationClass.value} *:tw-overflow-hidden`,
      invisible: 'tw-grid-cols-[0fr]',
      visible: 'tw-grid-cols-[1fr]',
    },
  }));

  const classAttributes = computed(() => {
    let enterType;
    let leaveType;

    if (typeof _props.type === 'object') {
      enterType = _props.type.enter;
      leaveType = _props.type.leave;
    } else {
      enterType = _props.type;
      leaveType = _props.type;
    }

    return {
      ...(enterType && {
        'enter-active-class': typeClasses.value[enterType].active,
        'enter-from-class': typeClasses.value[enterType].invisible,
        'enter-to-class': typeClasses.value[enterType].visible,
      }),
      ...(leaveType && {
        'leave-active-class': typeClasses.value[leaveType].active,
        'leave-to-class': typeClasses.value[leaveType].invisible,
        'leave-from-class': typeClasses.value[leaveType].visible,
      }),
    };
  });

  return {
    classAttributes,
  };
}
